var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCqLogoBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 567,
    viewBox: "0 0 512 567",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M567.332 0C724.079 0 850.995 126.716 850.995 283.219C850.995 355.78 823.712 421.939 778.823 472.033H850.999V566.439H756.445V494.376C706.272 539.196 640.009 566.438 567.332 566.438C410.585 566.438 283.67 439.721 283.67 283.219C283.67 126.716 410.585 0.000166554 567.332 0ZM283.41 566.438C127.081 566.438 0 439.556 0 283.471C0.000109729 127.386 127.081 0.503943 283.41 0.503906V566.438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCqLogoBackground);
export default __webpack_public_path__ + "static/media/cqLogoBackground.906d9748ec53ae19f949181cae10e718.svg";
export { ForwardRef as ReactComponent };